module.exports = {
  title: 'EleksyonPH',
  description: 'Alternative Rock injected with electronic and cinematic elements. Proud member of the FiXT roster.',
  keywords: 'soul extract, soulextract, alternative electronic rock, cinematic elements, fixt, fixt roster, science fiction',
  url: 'https://zaxatlas.site',
  twitter: '@isaacwork0105',
  seoImage: 'https://zaxatlas.site/images/soulextract.jpg',
  color: '#000000'
};
